var _a, _b, _c;
import { generateActions } from "../generators/generator.actions";
import { createCustomAction, EActionState } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./rentRegistration.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["BrusselsRegistrationRetry"] = "BRUSSELS_REGISTRATION_RETRY";
    EActionCustom["MyRentRegistrationRetry"] = "MY_RENT_REGISTRATION_RETRY";
})(EActionCustom || (EActionCustom = {}));
export var getDetailStart = (_a = generateActions(GENERATOR_PARAMS), _a.getDetailStart), getDetailStartNoThrottle = _a.getDetailStartNoThrottle, getDetailSucceeded = _a.getDetailSucceeded, getDetailFailed = _a.getDetailFailed, getPagedStart = _a.getPagedStart, getPagedStartNoThrottle = _a.getPagedStartNoThrottle, getPagedSucceeded = _a.getPagedSucceeded, getPagedFailed = _a.getPagedFailed, getCountStart = _a.getCountStart, getCountStartNoThrottle = _a.getCountStartNoThrottle, getCountSucceeded = _a.getCountSucceeded, getCountFailed = _a.getCountFailed, createStart = _a.createStart, createSucceeded = _a.createSucceeded, createFailed = _a.createFailed, updateStart = _a.updateStart, updateSucceeded = _a.updateSucceeded, updateFailed = _a.updateFailed, removeStart = _a.removeStart, removeSucceeded = _a.removeSucceeded, removeFailed = _a.removeFailed;
var generateBrusselsRegistrationRetryActions = function () { return ({
    brusselsRegistrationRetryStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.BrusselsRegistrationRetry,
        state: EActionState.Start,
    }),
    brusselsRegistrationRetrySucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.BrusselsRegistrationRetry,
        state: EActionState.Success,
    }),
    brusselsRegistrationRetryFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.BrusselsRegistrationRetry,
        state: EActionState.Fail,
    }),
}); };
var generateMyRentRegistrationRetryActions = function () { return ({
    myRentRegistrationRetryStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MyRentRegistrationRetry,
        state: EActionState.Start,
    }),
    myRentRegistrationRetrySucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MyRentRegistrationRetry,
        state: EActionState.Success,
    }),
    myRentRegistrationRetryFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.MyRentRegistrationRetry,
        state: EActionState.Fail,
    }),
}); };
export var brusselsRegistrationRetryStart = (_b = generateBrusselsRegistrationRetryActions(), _b.brusselsRegistrationRetryStart), brusselsRegistrationRetrySucceeded = _b.brusselsRegistrationRetrySucceeded, brusselsRegistrationRetryFailed = _b.brusselsRegistrationRetryFailed;
export var myRentRegistrationRetryStart = (_c = generateMyRentRegistrationRetryActions(), _c.myRentRegistrationRetryStart), myRentRegistrationRetrySucceeded = _c.myRentRegistrationRetrySucceeded, myRentRegistrationRetryFailed = _c.myRentRegistrationRetryFailed;
